import { ROW_HEIGHT, ROW_PADDING } from "../../../../constants/constants";
import { ProcessesColumnStyles } from "../../TimelinesStyles";
import { useProcessesInVisibleGroups } from "../../../../utils/customHooks/genericHooks";
import { useFlightTranslation } from "../../../../utils/customHooks/useFlightTranslation";
import { useHighlightOverlappingSegments } from "store/atoms";
import { ProcessNameLink } from "../../MachineBreakdownChart/subcomponents/ProcessNameLink";
import { useHighlightedTags } from "../../HubletView/SingleTimeline/singleTimelineStore";
import { Badge } from "@mui/material";
import {
  LINE_ROLE_ICONS,
  useLeaderConstraintProcessIds,
} from "../../Tiles/ProcessTile/LineRoleDecorator";
import { Process } from "types/types";

export const ProcessesColumn = ({ processes }: { processes: Process[] }) => {
  const { translate } = useFlightTranslation();
  const allProcesses = useProcessesInVisibleGroups();
  const [highlightedTags] = useHighlightedTags();
  const [highlightOverlappingSegments] = useHighlightOverlappingSegments();

  const areAnyTagsHighlighted = highlightedTags.length > 0;
  const showTagHighlight =
    highlightOverlappingSegments || areAnyTagsHighlighted;

  const { leaderProcessId, constraintProcessIds } =
    useLeaderConstraintProcessIds();

  return (
    <ProcessesColumnStyles
      className="machinesColumn"
      $showTagHighlight={showTagHighlight}
    >
      <div className="title machineTitle">{translate("Process")}</div>
      {processes.map((p, idx) => {
        const processIdx = allProcesses.findIndex(proc => proc.id === p.id);

        const isLeader = leaderProcessId === p.id;
        const isConstraint = constraintProcessIds?.includes(p.id);
        return (
          <Badge
            key={`p-${p.id}-${p.name}name`}
            badgeContent={
              isLeader
                ? LINE_ROLE_ICONS.LEADER
                : isConstraint
                  ? LINE_ROLE_ICONS.CONSTRAINT
                  : null
            }
            anchorOrigin={{ horizontal: "left", vertical: "top" }}
          >
            <div
              className={`processNameLinkWrapper ${
                isLeader || isConstraint ? "machineNameContainerWithBadge" : ""
              }`}
              style={{
                height: ROW_HEIGHT - ROW_PADDING,
                display: "flex",
                alignItems: "center",
              }}
            >
              <ProcessNameLink process={p} processIdx={processIdx} />
            </div>
          </Badge>
        );
      })}
    </ProcessesColumnStyles>
  );
};
